import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { Service } from "../service.class";

@Injectable({
	providedIn: "root",
})
export class ExcelGeneratorService {
	private xlsx_path: string = "/v2/sales/export";
	private xlsxTrials_path: string = "/v2/sales/export/trials";
	private report_path: string = "/v2/sales/report";

	constructor(private service: Service) { }

	public getExcelFromBack(body: any, filename: string, filters?: HttpParams): Observable<any> {
		let params: any = {};
		if (filters != undefined) {
			for (const key of filters.keys()) {
				params[key] = filters.getAll(key);
			}
		}

		params['filename'] = filename;

		return this.service.apiPostExcel(this.xlsx_path, body, params);
	}

	public getReportFromBack(body: any, filename: string): Observable<any> {
		return this.service.apiPostReport(this.report_path, body, { filename });
	}

	public getSalesTrialsExcel(body: any, filters?: HttpParams): Observable<any> {
		let params: any = {};
		if (filters != undefined) {
			for (const key of filters.keys()) {
				params[key] = filters.getAll(key);
			}
		}
		params["filename"] = "salesReport";
		return this.service.apiPostExcelWithoutParams(this.xlsxTrials_path, body, params);
	}

	public getAssignedLicensesExcel(filters?: HttpParams): Observable<BlobPart> {
		let params: any = {};

		if (filters !== undefined) {
			for (const key of filters.keys()) {
				params[key] = filters.getAll(key);
			}
		}

		params["filename"] = "assigned_licenses";
		return this.service.apiGetExcel("/v2/assigned-licenses/export", params);
	}
}
